/* eslint-disable @typescript-eslint/naming-convention */
import { FC, useRef, useState } from "react";

import { Box, CSSObject } from "@chakra-ui/react";
import Head from "next/head";
import Script from "next/script";

import getEnv from "@utils/getEnv";

import UserPositionButton from "./components/UserPositionButton";
import useLockersLayer from "./hooks/useLockersLayer";
import useMap from "./hooks/useMap";
import type { TMapLocker } from "./types";

type TLockersMapProps = {
  countryCode?: string;
  hasLockerPopups?: boolean;
  hasUserPosition?: boolean;
  hasPositionInit?: boolean;
  selectedLockerId?: string;
  onLockerSelect: (locker: TMapLocker) => void;
};

const mapBubblesStyle: CSSObject = {
  ".H_ib_body": {
    transform: "translateX(50%)",
    marginRight: "0",
  },
  ".H_ib_body .H_ib_close": {
    display: "none",
  },
  ".H_ib_body .H_ib_content": {
    margin: "0.5rem 1rem",
    fontFamily: "DPD Pluto Sans",
    minWidth: "10rem",
    textAlign: "center",
  },
};

const LockersMap: FC<TLockersMapProps> = ({
  countryCode,
  hasLockerPopups,
  hasUserPosition,
  hasPositionInit,
  selectedLockerId,
  onLockerSelect,
}) => {
  const [isScriptLoaded, setIsScriptLoaded] = useState(false);

  const mapNodeRef = useRef<HTMLDivElement>(null);

  const { map: lockersMap, ui: mapUI } = useMap(isScriptLoaded, mapNodeRef);

  useLockersLayer({ countryCode, lockersMap, mapUI, hasLockerPopups, selectedLockerId, onLockerSelect });

  // Loading scripts here, because we need to know when this script is loaded
  return (
    <>
      <Head>
        <link rel="stylesheet" type="text/css" href={getEnv("NEXT_PUBLIC_HERE_MAPS_CSS")} />
      </Head>
      <Script
        type="module"
        src={getEnv("NEXT_PUBLIC_HERE_MAPS_SCRIPT")}
        strategy="beforeInteractive"
        onLoad={() => setIsScriptLoaded(true)}
      />
      <Box position="relative" height="100%">
        <Box ref={mapNodeRef} width="100%" height="100%" sx={mapBubblesStyle} />
        {hasUserPosition && (
          <UserPositionButton map={lockersMap} selectedLockerId={selectedLockerId} hasPositionInit={hasPositionInit} />
        )}
      </Box>
    </>
  );
};
export default LockersMap;
